import * as React from 'react'

import MeCompanyQuickFilters from '~/client/src/shared/components/Filters/MeCompanyQuickFilters/MeCompanyQuickFilters'

import { TableFilters } from '../../TableFilters'
import { useResourceMeta } from '../context'

export const ResourceFilters: React.FC = () => {
  const { filterProps, quickFilters } = useResourceMeta()

  const resetAll = React.useCallback(() => {
    filterProps?.onResetAll()
  }, [filterProps])

  const filterPropsWithoutSearch = React.useMemo(
    () =>
      filterProps
        ? {
            facets: filterProps.facets,
            sourceMapByFacet: filterProps.sourceMapByFacet,
            appliedFilters: filterProps.appliedFilters,
            onFilterApply: filterProps.onFilterApply,
            onResetAll: resetAll,
            availableRecords: filterProps.availableRecords,
            getOptionName: filterProps.getOptionName,
          }
        : null,
    [filterProps, resetAll],
  )

  if (!filterPropsWithoutSearch) return null

  return (
    <div className="tw:flex tw:items-center tw:gap-1">
      <TableFilters {...filterPropsWithoutSearch}>
        <MeCompanyQuickFilters
          isOnlyMe={quickFilters.isOnlyMe}
          isOnlyMyCompany={quickFilters.isOnlyMyCompany}
          onToggleMe={quickFilters.toggleOnlyMe}
          onToggleMyCompany={quickFilters.toggleOnlyMyCompany}
          isMeDisabled={!quickFilters.hasUserProperties}
          isMyCompanyDisabled={!quickFilters.hasCompanyProperties}
        />
      </TableFilters>
    </div>
  )
}
